import React from 'react';

const IconMicrophone = () => (
 
  <svg version="1.1" id="microphone-icon" xmlns="http://www.w3.org/2000/svg"  xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    viewBox="0 0 442.345 442.344" 
     space="preserve">
    <g>
      <path d="M295.975,0c37.622,0,68.11,30.495,68.11,68.11c0,37.614-30.488,68.106-68.11,68.106c-37.609,0-68.105-30.492-68.105-68.106
		C227.869,30.495,258.365,0,295.975,0z"/>
      <path d="M148.576,256.536c5.681,0,10.722-2.561,14.183-6.532L277.4,144.44c-22.754-5.521-41.646-20.963-51.824-41.475
		l-90.567,120.557c-3.338,4.661-5.316,8.725-5.316,14.122C129.693,248.072,138.157,256.536,148.576,256.536z"/>
      <path d="M93.474,358.007c38.097,29.274,96.661-26.176,98.849-28.292c0.629-0.549,62.4-54.934,91.197-22.723
		c6.012,6.701,8.524,14.459,7.727,23.712c-3.029,34.308-50.674,78.774-68.785,93.009c-4.521,3.559-5.306,10.118-1.75,14.644
		c2.056,2.62,5.102,3.987,8.2,3.987c2.24,0,4.524-0.737,6.407-2.217c2.962-2.324,72.25-57.222,76.683-107.575
		c1.334-15.107-3.021-28.381-12.937-39.465c-12.695-14.198-36.695-26.878-78.794-6.668c-23.048,11.044-41.072,27.069-42.104,27.987
		c-12.385,11.854-52.203,42.259-72.002,27.054c-4.31-3.31-6.524-7.313-6.989-12.595c-1.559-18.238,17.721-44.495,27.312-55.483
		l21.362-7.449c0,0-4.278-0.477-14.351-9.506c-9.419-8.464-11.918-17.616-11.918-17.616l-9.614,19.532
		c-6.847,7.634-36.097,42.193-33.552,72.277C79.348,341.693,84.553,351.167,93.474,358.007z"/>
    </g>

  </svg>

);

export default IconMicrophone;
